module.exports = "assets/img/maison.png";